/**
 * Embedded desktop-app pages (WorkHub webview, etc.) use a `-app` path
 * suffix: `/login-app`, `/hub-app`, `/hub-app/task-details`.
 * Those pages must never show the website sidebar.
 */

export function isAppPagePath(pathname: string): boolean {
    if (!pathname) {
        return false
    }
    return pathname.split('/').some((segment) => segment.endsWith('-app'))
}
